import { Action } from 'redux';
// Import States.
import {
	AppState,
} from '@app/redux/states';
// Import Actions.
import {
	AddAppModeAction,
	RemoveAppModesAction,
} from '@app/redux/actions';
// Load enumerations.
import {
	AppMode
} from '@app/enumerations';


/**
 * This handles initializing the state.
 * @param state
 */
let initializeState = (state: AppState): AppState => {
	let newState: AppState = { ...state };
	newState.appMode = { ...newState.appMode };
	return newState;
}


// Add App Mode Reducer.

let AddAppModeReducer = (state: AppState, action: Action): AppState => {
	let addAppModeAction: AddAppModeAction = action as AddAppModeAction;
	let appMode: AppMode = addAppModeAction.appMode;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state);

	newState.appMode[appMode] = true;

	return newState;
}

// Remove App Mode Reducer.

let RemoveAppModesReducer = (state: AppState, action: Action): AppState => {
	let removeAppModesAction: RemoveAppModesAction = action as RemoveAppModesAction;
	let appModes: AppMode[] = removeAppModesAction.appModes;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state);
	// Add the app mode.
	appModes.forEach((appMode: AppMode) => {
		newState.appMode[appMode] = false;
	});


	return newState;
}

// Export reducers.
export {
	AddAppModeReducer,
	RemoveAppModesReducer,
};